export default __webpack_public_path__ + "7370c3679472e9560965ff48a4399d0b.woff2";